import { render, staticRenderFns } from "./review-result.vue?vue&type=template&id=f5647392&scoped=true"
import script from "./review-result.vue?vue&type=script&lang=js"
export * from "./review-result.vue?vue&type=script&lang=js"
import style0 from "./review-result.vue?vue&type=style&index=0&id=f5647392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5647392",
  null
  
)

export default component.exports